import React from 'react';
import Slider from 'react-slick';
import './TestimonialsSection.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "We needed experienced SAP specialists for a critical implementation, and NeuroverseAI delivered beyond expectations. Their team’s expertise ensured the project was completed on time with flawless execution.",
      author: "Manish Gupta",
      role: "IT Director"
    },
    {
      quote: "NeuroverseAI provided us with exceptional SAP talent for our ERP upgrade. The consultants quickly understood our needs and contributed to improving system efficiency.",
      author: "Pooja Sharma",
      role: "Project Manager"
    },
    {
      quote: "Partnering with NeuroverseAI for SAP staffing has been a game-changer for us. Their ability to provide highly skilled SAP consultants at short notice has helped us meet project deadlines seamlessly.",
      author: "Amit Desai",
      role: "Head of Operations"
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <Slider {...sliderSettings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-slide">
              <p className="testimonial-quote">"{testimonial.quote}"</p>
              <div className="testimonial-author-info">
                <h4 className="testimonial-author">- {testimonial.author}</h4>
                <p className="testimonial-role">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialsSection;